import { AppState } from '../types';

export const getMaxDateTime = (state: AppState): Date | null => state.shift.maxDateTime;
